import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  ContactAdvisor = 'ContactAdvisor',
}

export const queryKeys = {
  contactAdvisor: (clientId: number) => [
    QueryFeature.ContactAdvisor,
    QueryKey.ContactAdvisor,
    clientId,
  ],
};
